import { render, staticRenderFns } from "./CreateCallbotDialog.vue?vue&type=template&id=658393d6&scoped=true"
import script from "./CreateCallbotDialog.vue?vue&type=script&lang=ts"
export * from "./CreateCallbotDialog.vue?vue&type=script&lang=ts"
import style0 from "./CreateCallbotDialog.vue?vue&type=style&index=0&id=658393d6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658393d6",
  null
  
)

export default component.exports